module.exports = __webpack_public_path__ + "static/media/logo-alpha.8558c4cf.png";